import React, { useContext, useState } from 'react';
import { RicosContext, ModalContext } from 'ricos-context';
import { DividerData_Width } from 'ricos-schema';
import { DropdownButton } from 'wix-rich-content-toolbars-ui';
import { alignmentMap } from './dividerButtonsData.js';
import 'wix-rich-content-plugin-commons';
import '../../icons/SingleLineStyle.js';
import '../../icons/DoubleLineStyle.js';
import '../../icons/DashedLineStyle.js';
import '../../icons/DottedLineStyle.js';

const getDefaultAlignment = (langDir) => {
  return langDir === "rtl" ? "RIGHT" : "LEFT";
};
const DividerAlignmentButton = ({ toolbarItem, dataHook, id }) => {
  var _a;
  const { t, languageDir, isMobile } = useContext(RicosContext) || {};
  const modalService = useContext(ModalContext) || {};
  const node = toolbarItem.attributes.selectedNode;
  const [referenceElement, setReferenceElement] = useState(null);
  const getSelectedAlignment = () => {
    var _a2;
    return ((_a2 = node == null ? void 0 : node.attrs) == null ? void 0 : _a2.alignment) || getDefaultAlignment(languageDir);
  };
  const selectedAlignment = getSelectedAlignment();
  const SelectedAlignmentIcon = alignmentMap[`${selectedAlignment}`];
  const isButtonDisabled = ((_a = node == null ? void 0 : node.attrs) == null ? void 0 : _a.width) === DividerData_Width.LARGE;
  const closeModal = () => modalService.closeModal(id);
  const onAlignmentClick = (alignment) => {
    var _a2;
    (_a2 = toolbarItem.commands) == null ? void 0 : _a2.click({ value: alignment });
    closeModal();
  };
  const onClick = () => {
    modalService.isModalOpen(id) ? closeModal() : modalService == null ? void 0 : modalService.openModal(id, {
      componentProps: {
        getSelectedAlignment,
        onClick: onAlignmentClick,
        closeModal
      },
      layout: isMobile ? "drawer" : "toolbar",
      positioning: { referenceElement, placement: "bottom" }
    });
  };
  return /* @__PURE__ */ React.createElement(
    DropdownButton,
    {
      dataHook,
      active: modalService.isModalOpen(id),
      onClick,
      disabled: isButtonDisabled,
      setRef: setReferenceElement,
      Icon: SelectedAlignmentIcon,
      tooltip: t("TextAlignmentButton_Tooltip")
    }
  );
};

export { DividerAlignmentButton };
//# sourceMappingURL=DividerAlignmentButton.js.map
